module.exports = __webpack_public_path__ + "static/metric-a4108935c52eb68f84faf9f360501cb9.png";